import {Route} from "react-router-dom";
import UrlsConfig from "@/config/UrlsConfig";
import {lazy} from "react";

const ReferenceBookCountries = lazy(() => import("@/pages/ReferenceBooks/Lists/GEO/Countries/ReferenceBookCountries"));
const ReferenceBookCities = lazy(() => import("@/pages/ReferenceBooks/Lists/GEO/Citites/ReferenceBookCities"));

const urlsConfig = new UrlsConfig();

export function referenceBookGEORoutes() {
    return (
      <>
          <Route path={urlsConfig.referenceBookCountries.to} element={<ReferenceBookCountries/>}/>
          <Route path={urlsConfig.referenceBookCities.to} element={<ReferenceBookCities/>}/>
      </>
    );
}
